{
  "version": 1,
  "asset_id": "4c4f177a-da00-4408-8720-1592ce157fec",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/4c4f177a-da00-4408-8720-1592ce157fec/hero-primeiro-corte-poster.jpg",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/4c4f177a-da00-4408-8720-1592ce157fec/hero-primeiro-corte-poster.jpg",
  "original_filename": "hero-primeiro-corte-poster.jpg",
  "size": 34546,
  "content_type": "image/jpeg",
  "created_at": "2026-11-03T17:23:27Z"
}
